// src/context/ThemeContext.js
import React, { createContext, useState, useEffect } from 'react';

// Create a context
export const ThemeContext = createContext();

// Define the available themes
const themes = {
    light: 'light',
    dark: 'dark',
    system: 'system',
};

// ThemeProvider component
export const ThemeProvider = ({ children }) => {
    const [theme, setTheme] = useState(themes.system);

    // Update the theme based on the state
    useEffect(() => {
        const currentTheme =
            theme === themes.system
                ? (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? themes.dark : themes.light)
                : theme;
        
        // Update the background color and color scheme
        if (currentTheme === themes.dark) {
            document.documentElement.style.backgroundColor = '#233240'; // Dark background color
            document.documentElement.style.color = '#ffffff'; // White text color
        } else {
            document.documentElement.style.backgroundColor = '#ffffff'; // Light background color
            document.documentElement.style.color = '#000000'; // Black text color
        }

        document.documentElement.setAttribute('data-theme', currentTheme);
    }, [theme]);

    const toggleTheme = (newTheme) => {
        setTheme(newTheme);
    };

    return (
        <ThemeContext.Provider value={{ theme, toggleTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};
